module.exports = __webpack_public_path__ + "static/header-faee07b59e0819b7ecfead85145a92a0.jpg";